import CustomText from "../../atomic/CustomText";

interface EmptyStateProps {
  displayQuery: string;
}

function EmptyState({ displayQuery }: Readonly<EmptyStateProps>): JSX.Element {
  return (
    <div className="px-5 py-6 text-center">
      <CustomText
        text="No results found"
        fontWeight="font-semibold"
        fontSize="text-sm"
        className="text-[#101828] mb-2"
      />
      {displayQuery && (
        <CustomText
          text={`Your search "${displayQuery}" did not match. Please try again.`}
          fontWeight="font-normal"
          fontSize="text-sm"
          className="text-[#667085]"
        />
      )}
    </div>
  );
}

export default EmptyState;

